/* ===========================
IMPORTS
=========================== */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
// IMPORT - ELEMENTS
import Loader from '../Elements/Loader';
// IMPORT - Helpers
import Helpers from '../../Helpers';

/* ===========================
CLASS
=========================== */
class ModalTags extends Component {
  /* ===========================
  DEFAULT
  =========================== */
  /**
  * Main constructor of Component
  */
  constructor(props) {
    super(props);

    this.state = {
      tags: [],
      tag: '',
      errors: null,
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.get = this.get.bind(this);
    this.request = this.request.bind(this);
    this.handleRemoveTag = this.handleRemoveTag.bind(this);
  }

  /**
  * componentDidMount
  */
  componentDidMount() {
    this.get();
  }

  /* ===========================
  FUNCTIONS
  =========================== */
  /**
   * @param {function} callback
   * @param {function} failback
   */
  get(callback, failback) {
    this.props.updateLoadingModal(true);
    this.request(
      // callback
      (response) => {
        if (callback) {
          callback(response);
        } else if (response.player && response.player.tags) {
          this.setState({
            tags: (response.player.tags
              && response.player.tags.length > 0) ? response.player.tags : [],
          }, () => {
            this.props.updateLoadingModal(false);
          });
        }
      },
      // failback
      (error) => {
        if (failback) {
          failback(error);
        } else {
          this.setState({
            errors: error,
          }, () => {
            this.props.updateLoadingModal(false);
          });
        }
      },
    );
  }

  /**
   * @param {function} callback
   * @param {function} failback
   */
  request(callback, failback) {
    Helpers.httpRequest(
      `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_VERSION}/players/${this.props.data.id}`,
      'get',
      null,
      // callback
      (response) => {
        if (callback) {
          callback(response);
        }
      },
      // failback
      (error) => {
        if (failback) {
          failback(error);
        }
      },
    );
  }

  /**
   * @param {Event} event
   */
  handleSubmit(event) {
    if (this.props.data && this.props.data.id) {
      this.props.handleSubmit(true);

      Helpers.httpRequest(
        `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_VERSION}/players/${this.props.data.id}`,
        'put',
        JSON.stringify({
          player: {
            tags: (this.state.tag && this.state.tag.length > 0)
              ? [...this.state.tags.map((item) => item.name), ...[this.state.tag]]
              : this.state.tags.map((item) => item.name),
          },
        }),
        // callback
        () => {
          this.setState({
            tag: '',
          }, () => {
            this.props.handleSubmit(false);
            this.props.handleSubmitSuccess();
            this.get();
          });
        },
        // failback
        (error) => {
          this.setState({
            errors: error,
          }, () => {
            this.props.handleSubmit(false);
          });
        },
      );
    }

    event.preventDefault();
  }

  /**
   * @param {Event} event
   */
  handleChange(event) {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }

  /**
   * @param {string} tag
   */
  handleRemoveTag(tag) {
    this.setState((prevState) => ({
      tags: prevState.tags.filter((item) => item.name !== tag),
    }));
  }

  /* ===========================
  RENDER
  =========================== */
  render() {
    return (
      <div>
        {(!this.props.loading)
          ? (
            <div>
              <form id={this.props.id} onSubmit={this.handleSubmit}>
                <div className="form-group">
                  <input type="text" onChange={this.handleChange} className="form-control" placeholder="Tag Name" name="tag" disabled={this.props.submitted} value={this.state.tag} />
                </div>

                {(this.state.errors && Object.keys(this.state.errors).length > 0)
                  ? (
                    <div className="form-group">
                      <div className="alert alert-danger">
                        <ul>
                          {(Object.keys(this.state.errors).map((item) => (
                            <li key={`list-${item}`}>
                              <strong>{item}</strong>
                              {' '}
                              -
                              {' '}
                              {this.state.errors[item]}
                            </li>
                          )))}
                        </ul>
                      </div>
                    </div>
                  )
                  : null}
                {(this.props.submitted)
                  ? (<Loader />)
                  : null}
              </form>
              <div>
                {(this.state.tags && this.state.tags.length > 0)
                  ? (this.state.tags.map((item, key) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <div key={`tag-${key}`} className="tag btn-group btn-group-sm">
                      <button type="button" className="btn btn-rounded btn-info">
                        <i className="fa fa-tag" />
&nbsp;
                        {item.name}
                      </button>
                      <button onClick={() => this.handleRemoveTag(item.name)} type="button" className="btn btn-rounded btn-info">&times;</button>
                    </div>
                  )))
                  : null}
              </div>
            </div>
          )
          : ''}
      </div>
    );
  }
}

/* ===========================
PROPERTY TYPES
=========================== */
ModalTags.propTypes = {
  id: PropTypes.string,
  data: PropTypes.object,
  loading: PropTypes.bool,
  submitted: PropTypes.bool,
  updateLoadingModal: PropTypes.func,
  handleSubmit: PropTypes.func,
  handleSubmitSuccess: PropTypes.func,
};

/* ===========================
EXPORT
=========================== */
export default ModalTags;
